window.addEventListener('load', () => {
  setTimeout(() => {
    registerBeforeUnload()
  }, 1)
})

export function registerBeforeUnload() {
  const formEl = document.querySelector('form')
  if (formEl) {
    const beforeSerializeForm = serializeForm(formEl)
    const beforeImages = getFormImages(formEl)
    const beforeEditors = getEditorContents(formEl)
    const beforeTableEditors = getTableEditorContents(formEl)
    const beforeVideos = getFormVideos(formEl)

    // addEventListenerで登録するとundefinedをセットしても警告ダイアログが表示される
    window.onbeforeunload = function (e) {
      // 離脱防止ポップアップが有効な場合は、警告ダイアログを表示しない
      const popupState = formEl.getAttribute('data-popup-state')
      if (popupState && popupState === 'enabled') {
        return undefined
      }

      const afterSerializeForm = serializeForm(formEl)
      const afterImages = getFormImages(formEl)
      const afterEditors = getEditorContents(formEl)
      const afterTableEditors = getTableEditorContents(formEl)
      const afterVideos = getFormVideos(formEl)
      const commit = document.getElementsByName('commit')[0]
      if (!commit.disabled) {
        if (
          beforeSerializeForm !== afterSerializeForm ||
          beforeImages !== afterImages ||
          beforeEditors !== afterEditors ||
          beforeTableEditors !== afterTableEditors ||
          beforeVideos !== afterVideos
        ) {
          return 'このページを離れますか？' // 変更があった場合
        }
      }
      // undefinedをreturnした場合、警告ダイアログは表示されない
      return undefined
    }

    formEl.addEventListener('submit', (e) => {
      if (e.submitter.name !== 'preview') {
        window.onbeforeunload = null
      }
    })
  }
}

function serializeForm(form) {
  let s = []
  let excludedTypes = new Set(['button', 'file', 'reset', 'submit'])

  Array.from(form.elements).forEach((field) => {
    // フィールドが無効であるか、タイプが定義されていないか、除外対象のタイプである場合は処理しない
    if (field.disabled || !field.type || excludedTypes.has(field.type)) return

    // react-selectを使用しているフィールドの場合
    if (field.type === 'hidden' && field.classList.contains('react-select')) {
      s.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`)
    }
    // 複数選択可能なセレクトボックスの場合は選択されたすべてのオプションを処理
    else if (field.type === 'select-multiple') {
      Array.from(field.selectedOptions).forEach((option) => {
        s.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(option.value)}`)
      })
    }
    // チェックボックスでもラジオボタンでもない、またはチェックされている場合は値を抽出
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      s.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`)
    }
  })

  return s.join('&').replace(/%20/g, '+')
}

function getFormImages(form) {
  const imgElList = form.querySelectorAll('img')
  const imgSrcList = []

  for (const imgEl of imgElList) {
    imgSrcList.push(imgEl.src)
  }

  return imgSrcList.join(',')
}

function getEditorContents(form) {
  const editorElList = form.querySelectorAll('trix-editor')
  const editorContents = []

  for (const editorEl of editorElList) {
    editorContents.push(editorEl.value)
  }

  return editorContents.join(',')
}

function getTableEditorContents(form) {
  const editorElList = form.querySelectorAll('#summernote')
  const editorContents = []

  for (const editorEl of editorElList) {
    editorContents.push($(editorEl).summernote('code'))
  }

  return editorContents.join(',')
}

function getFormVideos(form) {
  const videoElList = form.querySelectorAll('video')
  const videoSrcList = []

  for (const videoEl of videoElList) {
    videoSrcList.push(videoEl.src)
  }

  return videoSrcList.join(',')
}
